import React from 'react';
import { LocationCard } from './LocationCard';
import { locations } from '../../data/locations';
export function LocationGrid() {
  return <section className="py-16 bg-white" data-id="element-569">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-570">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-571">
          {locations.map(location => <LocationCard key={location.id} location={location} data-id="element-572" />)}
        </div>
      </div>
    </section>;
}